module.exports = __webpack_public_path__ + "static/Q3_2023_Investor_call_Dial-in-information-326b627e6144ec68e4cca42b421fb3c2.pdf";